import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
// @ts-expect-error untyped dependency
import { getAppShortlink } from '../../../utils/urls';
// @ts-expect-error untyped dependency
import { getIsPublic } from '../../../selectors/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export default function WriteReviewButton({
  className,
  disabled = false,
  onClick,
  size = 'sm',
  tooltipPlacement = 'left',
  use = 'tertiary',
  unreviewableReason
}) {
  const {
    pathname
  } = useLocation();
  const isPublic = useSelector(getIsPublic);
  const isReviewable = !unreviewableReason;
  if (isPublic) {
    return /*#__PURE__*/_jsx(UIButton, {
      className: className,
      href: getAppShortlink(`${pathname}/write-review`),
      use: use,
      size: size,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.detail.reviews.write.button"
      })
    });
  }
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `marketplace-ui-reviews.error.${unreviewableReason}`
      }),
      disabled: isReviewable,
      placement: tooltipPlacement,
      children: /*#__PURE__*/_jsx(UIButton, {
        className: className,
        onClick: onClick,
        use: use,
        size: size,
        disabled: disabled || !isReviewable,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.detail.reviews.write.button"
        })
      })
    })
  });
}